module.exports = __webpack_public_path__ + "static/media/sales.ada9f34a.png";